"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountService = exports.DwQuotaPeriod = exports.DwCheckType = exports.DwChannel = exports.KycDocType = exports.KycUserLevel = exports.KycLevel = exports.KycResult = exports.ThirdAccountType = exports.VerifyFaceResult = exports.OtpState = exports.RedPacketType = exports.VerifyCodeAction = exports.VerifyCodeType = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
var VerifyCodeType;
(function (VerifyCodeType) {
    VerifyCodeType["sms"] = "sms";
    VerifyCodeType["email"] = "email";
    VerifyCodeType["voice"] = "voice";
})(VerifyCodeType = exports.VerifyCodeType || (exports.VerifyCodeType = {}));
var VerifyCodeAction;
(function (VerifyCodeAction) {
    VerifyCodeAction["login"] = "login";
    VerifyCodeAction["withdraw"] = "withdraw";
    VerifyCodeAction["register"] = "register";
    VerifyCodeAction["forgetPassword"] = "forget_password";
    VerifyCodeAction["accountBind"] = "account_bind";
    VerifyCodeAction["add_whitelist_address"] = "add_whitelist_address";
    VerifyCodeAction["modify_address_tag"] = "modify_address_tag";
    VerifyCodeAction["move_to_whitelist_address"] = "move_to_whitelist_address";
    VerifyCodeAction["move_out_whitelist_address"] = "move_out_whitelist_address";
    VerifyCodeAction["open_whitelist_withdraw"] = "open_whitelist_withdraw";
    VerifyCodeAction["close_whitelist_withdraw"] = "close_whitelist_withdraw";
    VerifyCodeAction["reset_otp"] = "reset_otp";
    VerifyCodeAction["kyc"] = "kyc";
    VerifyCodeAction["close_user"] = "close_user";
    VerifyCodeAction["account_unbind"] = "account_unbind";
    VerifyCodeAction["bind_otp"] = "bind_otp";
    VerifyCodeAction["reset_security_account"] = "reset_security_account";
    VerifyCodeAction["pay_subscription_fee"] = "pay_subscription_fee";
    VerifyCodeAction["openapi_createkey"] = "openapi_createkey";
    VerifyCodeAction["openapi_modifykey"] = "openapi_modifykey";
    VerifyCodeAction["openapi_delkey"] = "openapi_delkey";
    VerifyCodeAction["bind_biometric_keys"] = "bind_biometric_keys";
    VerifyCodeAction["fiat_currency_withdraw"] = "fiat_currency_withdraw";
    VerifyCodeAction["third_login"] = "3rd_login";
    VerifyCodeAction["third_bind"] = "3rd_bind";
    /**
     * 发红包
     */
    VerifyCodeAction["gift_box_send"] = "gift_box_send";
    VerifyCodeAction["swapx_transfer"] = "swapx_transfer";
    VerifyCodeAction["swapx_approve"] = "swapx_approve";
    VerifyCodeAction["swapx_swap"] = "swapx_swap";
    VerifyCodeAction["passkey_registration"] = "passkey_registration";
    VerifyCodeAction["passkey_unbind"] = "passkey_unbind";
    VerifyCodeAction["unbind_biometric_key"] = "unbind_biometric_key";
})(VerifyCodeAction = exports.VerifyCodeAction || (exports.VerifyCodeAction = {}));
/**
 * 红包类型
 */
var RedPacketType;
(function (RedPacketType) {
    /**
     * 随机
     */
    RedPacketType["Random"] = "random";
    /**
     * 定额
     */
    RedPacketType["Certain"] = "certain";
})(RedPacketType = exports.RedPacketType || (exports.RedPacketType = {}));
var OtpState;
(function (OtpState) {
    OtpState["BOUND"] = "bound";
    OtpState["NOT_BOUND"] = "not_bound";
    OtpState["NOT_CONFIRMED"] = "not_confirmed";
})(OtpState = exports.OtpState || (exports.OtpState = {}));
var VerifyFaceResult;
(function (VerifyFaceResult) {
    VerifyFaceResult["NOT_STARTED"] = "NOT_STARTED";
    VerifyFaceResult["PENDING"] = "PENDING";
    VerifyFaceResult["PASSED"] = "PASSED";
    VerifyFaceResult["RESUBMISSION"] = "RESUBMISSION";
    VerifyFaceResult["FAILED"] = "FAILED";
})(VerifyFaceResult = exports.VerifyFaceResult || (exports.VerifyFaceResult = {}));
var ThirdAccountType;
(function (ThirdAccountType) {
    ThirdAccountType["google"] = "google";
    ThirdAccountType["apple"] = "apple";
})(ThirdAccountType = exports.ThirdAccountType || (exports.ThirdAccountType = {}));
/**
 * KYC状态
 */
var KycResult;
(function (KycResult) {
    /**
     * 未认证
     */
    KycResult["NOT_STARTED"] = "NOT_STARTED";
    /**
     * 认证进行中
     */
    KycResult["PENDING"] = "PENDING";
    /**
     * 审核中
     */
    KycResult["REVIEWING"] = "REVIEWING";
    /**
     * IDV(身份认证)认证通过，可认为是一种特殊的审核中状态
     */
    KycResult["IDV_PASSED"] = "IDV_PASSED";
    /**
     * 验证通过
     */
    KycResult["PASSED"] = "PASSED";
    /**
     * 验证失败
     */
    KycResult["FAILED"] = "FAILED";
    /**
     * 验证失败，但可重新提交
     */
    KycResult["HALF_FAILED"] = "HALF_FAILED";
})(KycResult = exports.KycResult || (exports.KycResult = {}));
/**
 * KYC等级
 */
var KycLevel;
(function (KycLevel) {
    KycLevel[KycLevel["lv0"] = 0] = "lv0";
    KycLevel[KycLevel["lv1"] = 1] = "lv1";
    KycLevel[KycLevel["lv2"] = 2] = "lv2";
})(KycLevel = exports.KycLevel || (exports.KycLevel = {}));
/**
 * 用户等级
 */
var KycUserLevel;
(function (KycUserLevel) {
    KycUserLevel[KycUserLevel["lv0"] = 0] = "lv0";
    KycUserLevel[KycUserLevel["lv99"] = 99] = "lv99";
})(KycUserLevel = exports.KycUserLevel || (exports.KycUserLevel = {}));
var KycDocType;
(function (KycDocType) {
    KycDocType["ID_CARD"] = "ID_CARD";
    KycDocType["PASSPORT"] = "PASSPORT";
    KycDocType["DRIVING_LICENSE"] = "DRIVING_LICENSE";
    KycDocType["RESIDENCE_PERMIT"] = "RESIDENCE_PERMIT";
    KycDocType["OTHER"] = "OTHER";
})(KycDocType = exports.KycDocType || (exports.KycDocType = {}));
/**
 * 出入金通道
 */
var DwChannel;
(function (DwChannel) {
    DwChannel["COIN"] = "COIN";
    DwChannel["FBO"] = "FBO";
    DwChannel["KGI"] = "KGI";
    DwChannel["CIRCLE"] = "CIRCLE";
    DwChannel["CIRCLE_ACH"] = "CIRCLE-ACH";
    DwChannel["CIRCLE_CARD"] = "CIRCLE-CARD";
})(DwChannel = exports.DwChannel || (exports.DwChannel = {}));
/**
 * 出入金限额检类型
 */
var DwCheckType;
(function (DwCheckType) {
    /**
     * 法币入金滚动限额
     */
    DwCheckType["DEPOSIT_ROLLING_QUOTA_CHECK"] = "DEPOSIT_ROLLING_QUOTA_CHECK";
    /**
     * 法币入金单笔限额
     */
    DwCheckType["DEPOSIT_SINGLE_AMOUNT_CHECK"] = "DEPOSIT_SINGLE_AMOUNT_CHECK";
    /**
     * 法币出金滚动限额
     */
    DwCheckType["WITHDRAWAL_ROLLING_QUOTA_CHECK"] = "WITHDRAWAL_ROLLING_QUOTA_CHECK";
    /**
     * 法币出金单笔限额
     */
    DwCheckType["WITHDRAWAL_SINGLE_AMOUNT_CHECK"] = "WITHDRAWAL_SINGLE_AMOUNT_CHECK";
    /**
     * 提币滚动限额
     */
    DwCheckType["COINOUT_ROLLING_QUOTA_CHECK"] = "COINOUT_ROLLING_QUOTA_CHECK";
    /**
     *  提币T+N限额
     */
    DwCheckType["COINOUT_TPLUSN_QUOTA_CHECK"] = "COINOUT_TPLUSN_QUOTA_CHECK";
})(DwCheckType = exports.DwCheckType || (exports.DwCheckType = {}));
var DwQuotaPeriod;
(function (DwQuotaPeriod) {
    DwQuotaPeriod["day"] = "day";
    DwQuotaPeriod["day30"] = "30day";
    DwQuotaPeriod["week"] = "week";
    DwQuotaPeriod["month"] = "month";
})(DwQuotaPeriod = exports.DwQuotaPeriod || (exports.DwQuotaPeriod = {}));
var AccountService;
(function (AccountService) {
    function generateMfaParams(params) {
        return trade_utils_lib_1.ObservableUtils.postV2(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/generate_mfa_params/?ts=${Date.now()}`, params, null, true);
    }
    AccountService.generateMfaParams = generateMfaParams;
    function getCaptchaData(params) {
        return trade_utils_lib_1.ObservableUtils.postV2(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/mfa/txn/v1/fetch_captcha?ts=${Date.now()}`, params, null, true);
    }
    AccountService.getCaptchaData = getCaptchaData;
    function verifyCaptcha(params) {
        return trade_utils_lib_1.ObservableUtils.postV2(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/mfa/txn/v1/verify_captcha?ts=${Date.now()}`, params, null, true);
    }
    AccountService.verifyCaptcha = verifyCaptcha;
    function sendHyperlink(params) {
        return trade_utils_lib_1.ObservableUtils.postV2(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/mfa/txn/v1/send_hyperlink?ts=${Date.now()}`, params, null, true);
    }
    AccountService.sendHyperlink = sendHyperlink;
    function verifyHyperlink(params) {
        return trade_utils_lib_1.ObservableUtils.postV2(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/mfa/txn/v1/verify_hyperlink?ts=${Date.now()}`, params, null, true);
    }
    AccountService.verifyHyperlink = verifyHyperlink;
    function openHyperlink(link_id) {
        return trade_utils_lib_1.ObservableUtils.postV2(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/mfa/txn/v1/open_hyperlink?ts=${Date.now()}`, {
            link_id,
        });
    }
    AccountService.openHyperlink = openHyperlink;
    function confirmHyperlink(link_id, request_id) {
        return trade_utils_lib_1.ObservableUtils.postV2(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/mfa/txn/v1/confirm_hyperlink?ts=${Date.now()}`, {
            link_id,
            request_id,
        });
    }
    AccountService.confirmHyperlink = confirmHyperlink;
    function sendVerifyCode(params, token) {
        let requestTokenObservable;
        if (token) {
            requestTokenObservable = (0, rxjs_1.of)(token);
        }
        else {
            requestTokenObservable = (0, trade_utils_lib_1.getTradeDependencyInstance)().getAccessToken();
        }
        return requestTokenObservable.pipe((0, operators_1.mergeMap)((accessToken) => {
            const { types } = params, rest = __rest(params, ["types"]);
            return (0, rxjs_1.forkJoin)(types.map((type) => {
                return trade_utils_lib_1.ObservableUtils.post(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/mfa/txn/v1/send_verify_code?ts=${Date.now()}`, Object.assign({ type }, rest), {
                    Authorization: `Bearer ${accessToken}`,
                }).pipe((0, operators_1.map)(({ code_id }) => {
                    if (type === VerifyCodeType.sms) {
                        return {
                            sms_code_id: code_id,
                        };
                    }
                    else if (type === VerifyCodeType.voice) {
                        return {
                            voice_code_id: code_id,
                        };
                    }
                    else {
                        return {
                            email_code_id: code_id,
                        };
                    }
                }));
            })).pipe((0, operators_1.map)((data) => {
                return data.reduce((res, item) => {
                    return Object.assign(Object.assign({}, res), item);
                });
            }));
        }));
    }
    AccountService.sendVerifyCode = sendVerifyCode;
    function verifyVerifyCode(params) {
        return trade_utils_lib_1.ObservableUtils.postV2(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/mfa/txn/v1/verify_multi_codes?ts=${Date.now()}`, params, null, true);
    }
    AccountService.verifyVerifyCode = verifyVerifyCode;
    function withdraw(params) {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getTradingToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            return trade_utils_lib_1.ObservableUtils.postV2(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/withdraw/?ts=${Date.now()}`, params, { Authorization: `Bearer ${token.awsToken}|${token.tradingToken}|` });
        }));
    }
    AccountService.withdraw = withdraw;
    function getOtpState() {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((access_token) => {
            return trade_utils_lib_1.ObservableUtils.post(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/otp/query?ts=${Date.now()}`, {
                access_token,
            });
        }), (0, operators_1.map)((data) => data.data.type));
    }
    AccountService.getOtpState = getOtpState;
    function unbindOTP(otp_code) {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((access_token) => {
            return trade_utils_lib_1.ObservableUtils.get(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/otp/unbind`, {
                ts: Date.now(),
                access_token,
                otp_code,
            });
        }));
    }
    AccountService.unbindOTP = unbindOTP;
    function recaptchaAssessment(data) {
        return trade_utils_lib_1.ObservableUtils.postV2(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/account/pre_auth?ts=${Date.now()}`, data);
    }
    AccountService.recaptchaAssessment = recaptchaAssessment;
    function requestFaceParams(params) {
        return trade_utils_lib_1.ObservableUtils.postV2(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/mfa/txn/v1/fetch_face_params?ts=${Date.now()}`, params, null, true);
    }
    AccountService.requestFaceParams = requestFaceParams;
    function verifyFaceResult(params) {
        return trade_utils_lib_1.ObservableUtils.postV2(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/mfa/txn/v1/verify_face_result?ts=${Date.now()}`, params, null, true);
    }
    AccountService.verifyFaceResult = verifyFaceResult;
    function verifyThirdAccount(data) {
        return trade_utils_lib_1.NetworkUtils.postV2({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/third_account/verify`,
            data,
        }).pipe((0, operators_1.map)((data) => {
            return data.data;
        }));
    }
    AccountService.verifyThirdAccount = verifyThirdAccount;
    function verifyBiometric(params) {
        return trade_utils_lib_1.NetworkUtils.postV2({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/mfa/txn/v1/verify_biometric`,
            data: params,
            authorize: true,
        }).pipe((0, operators_1.map)((data) => {
            return data.data;
        }));
    }
    AccountService.verifyBiometric = verifyBiometric;
    /**
     * 获取IP定位信息
     */
    function getIpLocation() {
        return trade_utils_lib_1.NetworkUtils.get({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/iploc`,
        });
    }
    AccountService.getIpLocation = getIpLocation;
    /**
     * 获取IP可用信息
     * https://pionex.atlassian.net/wiki/spaces/account/pages/232456193/IP
     */
    function getIpAvailableData(params) {
        return trade_utils_lib_1.Network.get({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/ipavl`,
            data: params,
        }).pipe((0, operators_1.map)((data) => {
            if (data.action === "need_kyc_2") {
                data.available = false;
            }
            return data;
        }));
    }
    AccountService.getIpAvailableData = getIpAvailableData;
    /**
     * 获取用户的KYC信息
     */
    function getKycData() {
        return trade_utils_lib_1.NetworkUtils.getV2({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/user/get_kyc_info_v3`,
            authorize: true,
        }).pipe((0, operators_1.map)((data) => {
            var _a, _b;
            data.lv2Info = (_b = (_a = data.kycInfo) === null || _a === void 0 ? void 0 : _a.levelInfo) === null || _b === void 0 ? void 0 : _b.find((item) => item.level === 2);
            return data;
        }));
    }
    AccountService.getKycData = getKycData;
    /**
     * 获取用户的出入金额度
     * @param channel
     * @param direction
     * https://pionex.atlassian.net/wiki/spaces/account/pages/235897323#%E6%8C%89%E8%B5%84%E9%87%91%E9%80%9A%E9%81%93%E8%8E%B7%E5%8F%96%E7%94%A8%E6%88%B7%E8%A7%84%E5%88%99%E4%BF%A1%E6%81%AF
     */
    function getDwQuotas(channel, direction) {
        return trade_utils_lib_1.NetworkUtils.getV2({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/channel_rules/`,
            data: { channel, direction },
            authorize: true,
        });
    }
    AccountService.getDwQuotas = getDwQuotas;
    /**
     * 获取用户的出入金剩余额度
     * @param channel
     * @param direction
     * https://pionex.atlassian.net/wiki/spaces/account/pages/235897323#%E6%8C%89%E8%B5%84%E9%87%91%E9%80%9A%E9%81%93%E8%8E%B7%E5%8F%96%E7%94%A8%E6%88%B7%E5%89%A9%E4%BD%99%E9%A2%9D%E5%BA%A6
     */
    function getDwRemainQuotas(channel, direction) {
        return trade_utils_lib_1.NetworkUtils.getV2({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/channel_remain_quota/`,
            data: { channel, direction },
            authorize: true,
        });
    }
    AccountService.getDwRemainQuotas = getDwRemainQuotas;
    /**
     * 获取出金额度规则列表
     * @param params
     */
    function getQuotaRules(params) {
        return trade_utils_lib_1.NetworkUtils.getV2({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().walletApiHost}/quota_rules/`,
            data: Object.assign({ version: 2 }, params),
            authorize: true,
        });
    }
    AccountService.getQuotaRules = getQuotaRules;
    function generatePasskeyMfaParams(params) {
        return trade_utils_lib_1.Network.post({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/account/generate_mfa_params`,
            data: params,
            authType: trade_utils_lib_1.AuthType.Access,
        }).pipe((0, operators_1.map)((data) => {
            return data.data;
        }));
    }
    AccountService.generatePasskeyMfaParams = generatePasskeyMfaParams;
    function getPasskeyList() {
        return trade_utils_lib_1.Network.get({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/otp/get_all_passkeys`,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    AccountService.getPasskeyList = getPasskeyList;
    function renamePasskey(params) {
        return trade_utils_lib_1.Network.post({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/otp/rename_passkey`,
            data: params,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    AccountService.renamePasskey = renamePasskey;
    function fetchPasskeyParams(params) {
        return trade_utils_lib_1.Network.post({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/mfa/txn/v1/fetch_passkey_params`,
            data: params,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    AccountService.fetchPasskeyParams = fetchPasskeyParams;
    function verifyPasskey(params) {
        return trade_utils_lib_1.Network.post({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/mfa/txn/v1/verify_passkey`,
            data: params,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    AccountService.verifyPasskey = verifyPasskey;
    function unbindBiometrics(params) {
        return trade_utils_lib_1.Network.post({
            url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountHost}/otp/unbind_biometric_key`,
            data: params || {},
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    AccountService.unbindBiometrics = unbindBiometrics;
})(AccountService = exports.AccountService || (exports.AccountService = {}));
